export default "__VITE_ASSET__Dulm5JFQ__"